import { type ReactNode } from 'react'

import { cn } from '@gto/ui/cn'
import { Typography } from '@gto/ui/typography'

type RailSectionProps = { title: string; children: ReactNode; className?: string }

/** Eyebrow-titled section inside the identity rail, divided from the previous one. */
export const RailSection = ({ title, children, className }: RailSectionProps) => (
  <div className={cn('flex flex-col gap-2 border-t border-divider pt-3', className)}>
    <Typography
      // tracking-[0.08em] is a slightly tighter eyebrow for sub-sections in
      // the rail. No letterSpacing token covers em values.
      className="text-xs font-semibold uppercase tracking-[0.08em]"
      color="text.secondary"
      variant="caption"
    >
      {title}
    </Typography>
    {children}
  </div>
)
